import { clsx } from 'clsx'

type FigcaptionProps = {
  children: string
  asOverlay: boolean
}

const baseTypographyClasses = 'text-start text-xs'

export const Figcaption = (props: FigcaptionProps) => {
  const { children, asOverlay } = props

  if (asOverlay) {
    return <OverlayCaption>{children}</OverlayCaption>
  }
  return (
    <figcaption
      className={clsx(
        baseTypographyClasses,
        'text-content-subdued',
        'px-0.5 my-1 max-w-prose',
      )}
    >
      {children}
    </figcaption>
  )
}

const OverlayCaption = (props: { children: string }) => {
  const { children } = props
  return (
    <figcaption
      data-as-overlay="true"
      className={clsx(
        baseTypographyClasses,
        'text-white',
        'bg-black/70 backdrop-blur-sm',
        'absolute bottom-0 end-0 w-full max-h-full overflow-y-scroll p-2',
        'rounded-b-md rounded-b-base',
      )}
    >
      {children}
    </figcaption>
  )
}
